@if (loading()) {
    <div class="flex items-center gap-3 py-6 text-muted-color">
        <p-progress-spinner styleClass="!w-6 !h-6" strokeWidth="4" />
        <span class="text-sm">Loading template info…</span>
    </div>
} @else if (!brandKit()) {
    <p-message severity="secondary" styleClass="text-sm" [text]="emptyMessage()" />
} @else {
    <div class="flex flex-col gap-5">
        <div class="text-xs font-mono text-muted-color">
            {{ brandKit()!.templateId }}@if (brandKit()!.version) { · v{{ brandKit()!.version }} }
        </div>

        @if (hasStyleInfo()) {
            <div class="flex flex-col gap-3 pb-4 border-b border-surface-200 dark:border-surface-700">
                <div class="font-semibold">Style</div>

                @if (styleDescription(); as desc) {
                    <p class="text-sm text-muted-color m-0">{{ desc }}</p>
                }

                @if (paletteColors().length > 0) {
                    <div class="flex flex-col gap-1.5">
                        <div class="text-xs uppercase tracking-wide text-muted-color">Palette</div>
                        <div class="flex flex-wrap gap-2">
                            @for (c of paletteColors(); track c.hex + c.role) {
                                <button
                                    type="button"
                                    class="flex items-center gap-2 pl-1 pr-2 py-1 rounded border border-surface-200 dark:border-surface-700 hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors"
                                    [pTooltip]="(c.name || 'color') + (c.role ? ' · ' + c.role : '') + ' — click to copy'"
                                    tooltipPosition="top"
                                    (click)="copyHex(c.hex)"
                                >
                                    <span class="w-6 h-6 rounded border border-surface-300 dark:border-surface-600 flex-shrink-0" [style.backgroundColor]="c.hex"></span>
                                    <span class="text-xs font-mono">{{ c.hex }}</span>
                                </button>
                            }
                        </div>
                    </div>
                }

                @if (typographyEntries().length > 0) {
                    <div class="flex flex-col gap-1.5">
                        <div class="text-xs uppercase tracking-wide text-muted-color">Typography</div>
                        <div class="flex flex-wrap gap-x-6 gap-y-1">
                            @for (t of typographyEntries(); track t.label) {
                                <div class="text-sm">
                                    <span class="text-muted-color">{{ t.label }}:</span>
                                    <span class="font-medium" [style.fontFamily]="t.value">{{ t.value }}</span>
                                </div>
                            }
                        </div>
                    </div>
                }

                @if (personalityTags().length > 0) {
                    <div class="flex flex-wrap gap-1.5">
                        @for (tag of personalityTags(); track tag) {
                            <p-tag severity="secondary" [value]="tag" [rounded]="true" />
                        }
                    </div>
                }
            </div>
        }

        @if (brandKit()!.references.length > 0) {
            <div class="flex flex-col gap-2 pb-4 border-b border-surface-200 dark:border-surface-700">
                <div class="font-semibold">Brand-icon references <span class="text-xs font-normal text-muted-color">({{ brandKit()!.references.length }})</span></div>
                <div class="grid grid-cols-2 gap-2">
                    @for (ref of brandKit()!.references; track ref.dataUrl) {
                        <div class="aspect-video rounded border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800 overflow-hidden flex items-center justify-center">
                            <img [src]="ref.dataUrl" alt="Brand reference" class="w-full h-full object-contain" />
                        </div>
                    }
                </div>
            </div>
        }

        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="flex flex-col gap-2">
                <div class="font-semibold">Favicon</div>
                @if (brandKit()!.favicon; as fav) {
                    <div class="w-16 h-16 rounded border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800 flex items-center justify-center overflow-hidden">
                        <img [src]="fav.dataUrl" alt="Favicon" class="w-10 h-10 object-contain" />
                    </div>
                } @else {
                    <span class="text-sm text-muted-color italic">none</span>
                }
            </div>

            <div class="flex flex-col gap-2">
                <div class="font-semibold">OG base plate</div>
                @if (brandKit()!.ogBasePlate; as og) {
                    <div class="rounded border border-surface-200 dark:border-surface-700 bg-surface-50 dark:bg-surface-800 overflow-hidden">
                        <img [src]="og.dataUrl" alt="OG base plate" class="w-full object-contain" />
                    </div>
                } @else {
                    <span class="text-sm text-muted-color italic">none</span>
                }
            </div>
        </div>
    </div>
}
